import { ResolveFn } from '@angular/router';
import { Workspace } from '../models';
import { WorkspaceService, ThemeService } from '../services';
import { inject } from '@angular/core';
import { AccountService, ProfileService } from '../api';
import { Auth } from '@angular/fire/auth';
import { of, switchMap, tap, map, combineLatest } from 'rxjs';

export const dashboardResolver: ResolveFn<Workspace[] | null> = () => {
  const workspaceService = inject(WorkspaceService);
  const profileService = inject(ProfileService);
  const accountService = inject(AccountService);
  const themeService = inject(ThemeService);
  const user = inject(Auth).currentUser;

  if (!user) {
    return of(null);
  }

  return profileService.getOrCreateProfile(user).pipe(
    tap((profile) => {
      profileService.setProfile(profile);
      profileService.setProfile$(profile);
      // Initialize theme from profile data
      if (profile?.settings?.theme) {
        themeService.setThemeFromProfile(profile.settings.theme);
      } else {
        themeService.setThemeFromSystemPreference();
      }
    }),
    switchMap((profile) =>
      accountService.getAccountsByProfileId(profile.id).pipe(
        switchMap((accounts) => {
          accountService.accounts.set(accounts);

          const workspaceObservables = accounts.map((account) =>
            workspaceService.getWorkspacesByAccountId(account.id),
          );

          // Fetch workspaces for all accounts in parallel.
          return combineLatest(workspaceObservables).pipe(
            map((workspaceArrays) => workspaceArrays.flat()),
          );
        }),
      ),
    ),
  );
};
